/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
  data: null
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.calenderDataAction.REQUEST_CALENDER_DATA:
      return {
        ...state
      };
    case actions.calenderDataAction.CALENDER_DATA_RECEIVED:
    
      return {
        ...state,
        data: action?.data
            
       
      };

    default:
      return state;
  }
};

export default reducer;
